/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Clients_Fleet_EmptyInputs */

const en_clients_fleet_empty = /** @type {(inputs: Clients_Fleet_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No fleet types added.`)
};

const pt_br2_clients_fleet_empty = /** @type {(inputs: Clients_Fleet_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nenhum tipo de frota adicionado.`)
};

/**
* | output |
* | --- |
* | "No fleet types added." |
*
* @param {Clients_Fleet_EmptyInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const clients_fleet_empty = /** @type {((inputs?: Clients_Fleet_EmptyInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Clients_Fleet_EmptyInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_clients_fleet_empty(inputs)
	return pt_br2_clients_fleet_empty(inputs)
});